import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'previewLocalImage',
    standalone: true,
})
export class PreviewLocalImagePipe implements PipeTransform {
    transform(value: File): any {
        if (value) {
            const url = URL.createObjectURL(value);

            return url;
        }
    }
}
